var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"bdg-map w-full"},[(_vm.staticMapImage)?_c('img',{attrs:{"alt":"Google Map of Contract address","src":_vm.staticMapImage}}):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }